import React from 'react';
import BaseCascader from './BaseCascader';
import { buildAreaTree } from './utils';
import ToastUtils from '@/utils/ToastUtils';

/**
 * data_source 与必选层级的映射
 */
const REQUIRED_LEVEL_MAP = {
    province: 1,                    // 仅省
    province_city: 2,               // 省市
    province_city_district: 3       // 省市区县
};

/**
 * AreaCascader - 省市区县级联子类
 *
 * 继承 BaseCascader，重写两个方法：
 * 1. convertToTree - 使用 buildAreaTree 进行层级裁剪
 * 2. handleChange - 增加必选层级校验
 *
 * data_source 类型：
 * - province: 省（1级）
 * - province_city: 省市（2级）
 * - province_city_district: 省市区县（3级）
 */
const AreaCascader = (props) => {
    const { setting = {} } = props;
    const dataSource = setting.data_source || 'province_city_district';
    const requiredLevel = REQUIRED_LEVEL_MAP[dataSource] || 3;

    /**
     * 自定义树转换：按层级裁剪
     */
    const customConvertToTree = (rawData) => {
        return buildAreaTree(rawData, requiredLevel);
    };

    /**
     * 自定义 change 处理：必选校验
     * @param {Array} val - 选中的值数组
     * @param {Object} ctx - 上下文对象（包含 formInstance, en_name, getLabelsByCodes）
     * @returns {boolean|undefined} 返回 false 阻止选择
     */
    const customHandleChange = (val, ctx) => {
        // 校验：选中层级是否达到要求
        if (requiredLevel && val?.length < requiredLevel) {
            ToastUtils.showToast('请选择');
            return false; // 阻止未选到底的情况
        }

        // 正常赋值
        const labels = ctx.getLabelsByCodes(val);
        ctx.formInstance?.setFieldsValue({
            [ctx.en_name]: val,
            [`${ctx.en_name}_name`]: labels
        });
    };

    return (
        <BaseCascader
            {...props}
            customConvertToTree={customConvertToTree}
            customHandleChange={customHandleChange}
        />
    );
};

export default AreaCascader;
